// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "checkbox-3mtaI";
var _4 = "active-1MJ5J";
var _5 = "notes-2ZucL";
var _6 = "form-1yToC";
export { _1 as "__esModule", _2 as "tablet", _3 as "checkbox", _4 as "active", _5 as "notes", _6 as "form" }
export default { "__esModule": _1, "tablet": _2, "checkbox": _3, "active": _4, "notes": _5, "form": _6 }
